import { Component } from '@angular/core';

import { ERoutes } from 'src/app/core/enums/routes.enum';

export interface INavItem {
  route: ERoutes;
  text: string;
}

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    standalone: false
})
export class NavMenuComponent {
  public readonly navItems: INavItem[] = [
    { route: ERoutes.ABOUT_US, text: 'Our mission' },
    { route: ERoutes.TRIP_TESTIMONIALS, text: 'People are saying' },
  ];
}
